import React from 'react';
import { connect } from 'react-redux';
import { Control, Form } from 'react-redux-form';
import get from 'lodash/get';

import {
  fetchOfferingDocuments,
  createUserFileSignatureLink,
  createAuthToken,
} from '../../../actions';
import BaseDetailScreen from '../../BaseDetailScreen';
import Button from '../../Button';
import CheckOption from '../components/CheckOption';
import DocumentOption from '../components/DocumentOption';
import InputField from '../../Forms/Controls/Field';
import Signature, { SIGNATURE_TYPE } from '../../SignUp/Signature';
import { externalOfferOrderDisclosuresPath } from '../../Forms/Schemas/baseRrf';
import { formatCurrency } from '../../Currency';

import './styles.css';


class Component extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sigLink: '',
    };
  }
  async componentWillMount() {
    if (!this.props.documents || !Object.keys(this.props.documents).length) {
      this.props.fetchOfferingDocuments(this.props.offer.id);
    }

    const authToken = await this.props.createAuthToken({
      expiresIn: 30 * 60, // 30 minutes
      scope: ['user:file'],
    });

    const sigLink = await this.props.createUserFileSignatureLink(authToken);
    this.setState({
      sigLink,
    });
  }

  toggleSignatureInput = () => {
    this.setState({ showSignatureInput: !this.state.showSignatureInput });
  }


  render() {
    const {
      offer,
      documents,
      documentsFetching,
      isConditional,
    } = this.props;
    const {
      sigLink,
      showSignatureInput,
    } = this.state;

    const fields = [
      {
        model: '.reviewedDocuments',
        RRFComp: Control.checkbox,
        control: {
          component: CheckOption,
          errors: {
            required: val => !val,
          },
          mapProps: {
            isToggle: true,
            children: 'I have reviewed the above offering documents and understand there are risks when investing. By clicking "continue" I am electronically signing the offering documents.',
          },
        },
        error: {
          messages: {
            required: 'Please review all the included documents before continuing.',
          },
        },
      },
    ];

    // TODO MJF: add min max share price value confirmation for conditional orders

    if (documentsFetching) {
      return (
        <BaseDetailScreen
          pageHeading="Review Offering Documents"
          pageSubheading="Please review all included documents before completing the order process."
          backTo={`/external-invest/${offer.id}/amount`}
          backLabel="Edit Order"
        >
          <div styleName="main">
            Loading documents ...
          </div>
        </BaseDetailScreen>
      );
    }

    let documentOptions = Object.keys(documents)
      .filter(k => (
        k !== 'investorPresentation' && k !== 'offeringCircularDocument'
      ))
      .map(k => (
        <DocumentOption
          location={documents[k]}
          name={k}
          key={`${offer.id}-${k}`}
        />
      ));

    if (documentOptions.length === 0) {
      documentOptions = (
        <div>There are currently no documents available for this offering.</div>
      );
    }

    return (
      <BaseDetailScreen
        pageHeading="Review Offering Documents"
        pageSubheading="Please review all included documents before completing the order process."
        backTo={`/external-invest/${offer.id}/amount`}
        backLabel="Edit Order"
      >
        <div styleName="main">
          { documentOptions }
          <Form
            model={externalOfferOrderDisclosuresPath}
            onSubmit={this.props.onNext}
          >
            <div styleName="checkboxContainer">
              {fields.map(field => (
                <InputField
                  key={field.model}
                  fieldProps={field}
                  id={field.model}
                />
              ))}
            </div>
            {!showSignatureInput ?
              <React.Fragment>
                <div styleName="signatureImageContainer">
                  <img styleName="signatureImage" alt="signature" src={sigLink} />
                </div>
                <div
                  onClick={this.toggleSignatureInput}
                  onKeyPress={this.toggleSignatureInput}
                  role="button"
                  styleName="drawOption"
                  tabIndex={0}
                >
                  Modify Signature
                </div>
              </React.Fragment> : <Signature signatureType={SIGNATURE_TYPE.OFFER_INVEST} />}
            {
                isConditional ?
                  <div styleName="conditionalDisclaimer">
                    {`This order will be automatically submitted if the final offering price is within the estimated share range of ${formatCurrency(offer.minSharePrice)} to ${formatCurrency(offer.maxSharePrice)}.`}
                  </div> : null
              }
            <div styleName="submitButtonContainer">
              <Button type="submit">
                Continue
              </Button>
            </div>
          </Form>
        </div>
      </BaseDetailScreen>
    );
  }
}

Component.displayName = 'ReviewDisclosureDocuments';

const mapStateToProps = (state, ownProps) => ({
  documents: get(state, `offeringDocumentsByOffer.data.${ownProps.offer.id}`, {}),
  documentsFetching: get(state, 'offeringDocumentsByOffer.isFetching', true),
});

const mapDispatchToProps = ({
  fetchOfferingDocuments,
  createAuthToken,
  createUserFileSignatureLink,
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/ExternalInvest/InvestmentViews/ReviewDisclosureDocuments.js